import React, { useEffect, useState } from "react";
import { Box, Typography, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useDropzone } from "react-dropzone";
import DescriptionIcon from "@material-ui/icons/Description";
import { UploadDocumentIcon } from "./uploadDocumentIcon";
import { DeleteForever } from "@material-ui/icons";

const useStyles = makeStyles(() => ({
  dropzoneBox: {
    border: "1.5px dashed #3f51b5",
    backgroundColor: "#f3f6f9",
    padding: "24px",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    gap: "16px",
    width: "100%",
    cursor: "pointer",
    height: "20%",
  },
  fileBox: {
    border: "1px solid #e0e0e0",
    backgroundColor: "#fafafa",
    padding: "20px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    width: "100%",
    justifyContent: "space-between",
    height: "20%",
  },
  fileDetails: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    height: "20%",
  },
  fileText: {
    display: "flex",
    flexDirection: "column",
  },
  fileName: {
    color: "#1565c0",
    fontWeight: 500,
    fontSize: 16,
    textDecoration: "underline",
    cursor: "pointer",
  },
  fileMeta: {
    color: "#757575",
    fontSize: 14,
    marginTop: 4,
  },
  icon: {
    fontSize: 42,
    color: "#757575",
  },
  deleteIcon: {
    color: "#f44336",
  },
}));

export const DropzoneArea = ({ file, setFile, store }) => {
  const classes = useStyles();
  const [fileMeta, setFileMeta] = useState({ size: "", rows: "" });

  const handleDrop = async (acceptedFiles: File[]) => {
    const uploadedFile = acceptedFiles[0];
    setFile(uploadedFile);
  };

  const getFileMetadata = async (file: File) => {
    await store.getFileMetaData(file);
    const fileMetaData = store?.fileMetaData;
    const size = fileMetaData?.size + 'kb';
    const rowCount = fileMetaData?.rows;
    setFileMeta({ size, rows: `${rowCount} Rows` });
  };

  useEffect(() => {
    if (file) getFileMetadata(file);
  }, [file]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: handleDrop,
    accept: ".xls,.xlsx",
    multiple: false,
  });

  return file ? (
    <Box className={classes.fileBox}>
      <Box className={classes.fileDetails}>
        <DescriptionIcon className={classes.icon} />
        <Box className={classes.fileText}>
          <Typography className={classes.fileName}>{file.name}</Typography>
          <Typography className={classes.fileMeta}>
            {fileMeta.size} / {fileMeta.rows}
          </Typography>
        </Box>
      </Box>
      <IconButton
        size="small"
        onClick={() => setFile(null)}
        className={classes.deleteIcon}
      >
        <DeleteForever />
      </IconButton>
    </Box>
  ) : (
    <Box {...getRootProps()} className={classes.dropzoneBox}>
      <input {...getInputProps()} />
      <UploadDocumentIcon />
      <Box>
        <Typography style={{ fontWeight: 500 }}>
          {isDragActive
            ? "Drop the file here..."
            : "Drag and drop your document here or"}
        </Typography>
        <Typography style={{ color: "#3f51b5", textDecoration: "underline" }}>
          click here to browse
        </Typography>
      </Box>
    </Box>
  );
};
